<template>
    <div>
        <load-screen-component :isLoading="isLoading"></load-screen-component>
        <page-header :btnNew="this.$hasPermission('MaritalStatuses_create') ? 'ACTIONS.NEW' : null" pageTitle="MARITAL_STATUSES.INDEX_TITLE"
                     @newType="setRegisterModal"/>

        <div class="mb-3 text-right" v-if="isUserR2()">
            <button
                data-cy="sync-marital-statuses"
                class="btn btn-warning"
                data-toggle="modal"
                data-target="#customModalTwo"
                @click="prepSyncModal">
                <i class="icon-sync mr-1"></i>{{ t('ACTIONS.SYNC') }}
            </button>
        </div>

        <list-component :items="items.data" v-if="items && items.data" :haveDetails="false">
            <template v-slot:principal-info="{items}">
                <div class="list-primary hide-text">{{ items.iten.name }}</div>
            </template>
            <template v-slot:dropdown-options="items">
                <div class="dropdown-item pointer text-white" data-target="#customModalTwo" data-toggle="modal"
                     data-cy="edit-marital-status"
                     @click="setEditModal(items.iten)" v-if="this.$hasPermission('MaritalStatuses_update')">
                    <i class="icon-edit mr-2 font-15"/>{{ t('ACTIONS.EDIT') }}
                </div>
                <div class="dropdown-item pointer text-white" data-cy="delete-marital-status"
                     @click="showAlert(items.iten.id)" v-if="this.$hasPermission('MaritalStatuses_delete')">
                    <i class="icon-delete mr-2 font-15"/>{{ t('ACTIONS.DELETE') }}
                </div>
            </template>
        </list-component>

        <pagination-component v-if="items && items.data" :items="items" :to="'/estadosCivis'"
                              @changePage="index($event)"></pagination-component>

        <div class="card" v-if="items && !items.data">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{
                            t('GENERAL.MSG.NO_REGISTER', {name: t('MARITAL_STATUSES.MARITAL_STATUSES'), os: 'os'})
                        }}</h5>
                </div>
            </div>
        </div>

        <modal :titleModal="modalTitle">
            <template v-slot:title>{{ t(modalTitle) }}</template>

            <div class="modal-body" v-if="isSyncFlow">
                <p class="mb-2">{{ t('MARITAL_STATUSES.SYNC.CONFIRM_MSG') }}</p>
                <ul class="sync-list">
                    <li>{{ t('MARITAL_STATUSES.SYNC.CHECK_DUPLICATES') }}</li>
                    <li>{{ t('MARITAL_STATUSES.SYNC.CHECK_RULES') }}</li>
                    <li>{{ t('MARITAL_STATUSES.SYNC.CHECK_INTEGRATIONS') }}</li>
                </ul>
            </div>
            <div class="modal-footer2" v-if="isSyncFlow">
                <button class="btn btn-secondary" data-dismiss="modal" type="button" :disabled="isSyncing">
                    {{ t('ACTIONS.CANCEL') }}
                </button>
                <button
                    data-cy="confirm-sync-marital-statuses"
                    class="btn btn-primary ml-2"
                    type="button"
                    @click="confirmSync"
                    :disabled="isSyncing"
                >
                    <span v-if="!isSyncing">{{ t('ACTIONS.CONFIRM') }}</span>
                    <span v-else><i class="icon-autorenew mr-1 spin"></i>{{ t('GENERAL.MSG.PROCESSING') }}</span>
                </button>
            </div>

            <form v-else @submit.prevent="create">
                <div class="modal-body">
                    <div class="form-group">
                        <label for="inputName" class="required">{{ t('GENERAL.NAME') }}: </label>
                        <input id="name" v-model="name" class="form-control" name="name" placeholder="Digite o nome"
                               type="text" @keyup="inputName(name)">

                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="spouse_signature_required"
                                   v-model="maritalStatus.spouse_signature_required">
                            <label class="custom-control-label"
                                   for="spouse_signature_required">{{
                                    t('MARITAL_STATUSES.SPOUSE_SIGNATURE_REQUIRED')
                                }}</label>
                        </div>

                        <div v-if="isNameInvalid" class="validation">{{ t(msgError) }}</div>
                    </div>
                </div>
                <div class="modal-footer2">
                    <div class="justify-content-left">
                        <h5 class="ml-2" style="color: red; font-size: .7rem;">{{ t('GENERAL.REQUIRED_FIELDS') }} *</h5>
                    </div>
                    <div class="ml-custom">
                        <button data-cy="marital_status_create_close" class="btn btn-secondary" data-dismiss="modal"
                                type="button">
                            {{ t('ACTIONS.CLOSE') }}
                        </button>
                        <button data-cy="marital_status_create_save" class="btn btn-primary ml-2" type="submit">
                            {{ t('ACTIONS.SAVE') }}
                        </button>
                    </div>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>

import jwt_decode from "jwt-decode";
import {useI18n} from "vue-i18n";
import {defineComponent} from 'vue';
import Modal from "@/components/modal";
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';
import maritalStatuses from '@/services/maritalStatuses';
import pageHeader from "@/components/layouts/pageHeader";
import ListComponent from '@/components/layouts/listComponent.vue';
import PaginationComponent from "@/components/layouts/PaginationComponent";
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import {mapState} from 'vuex';

export default defineComponent({
    name: 'indexMaritalStatuses',
    mixins: [Validate],
    components: {
        Modal,
        pageHeader,
        ListComponent,
        PaginationComponent,
        loadScreenComponent
    },
    computed: {
        ...mapState({
            isLoading: 'isLoading'
        })
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            isSyncing: false,
            isSyncFlow: false,
            msg: '',
            id: null,
            type: {},
            items: null,
            modalTitle: '',
            maritalStatus: {},
            config: {
                min: 0,
                suffix: '',
                masked: true,
                decimal: ',',
                precision: 2,
                prefix: 'R$ ',
                thousands: '.',
                disabled: false,
                allowBlank: false,
                max: 500,
                disableNegative: true,
                minimumNumberOfCharacters: 1
            }
        }
    },

    mounted() {
        this.$canAccess('MaritalStatuses_index');
        this.$store.commit('changeLoading', true);
        this.index();
    },

    methods: {
        isUserR2() {
            try {
                const raw = localStorage.getItem('access_token');
                if (!raw) return false;
                const token = jwt_decode(raw);
                return typeof token?.login === 'string' && token.login.endsWith('@r2soft.com.br');
            } catch {
                return false;
            }
        },

        prepSyncModal() {
            this.isSyncFlow = true;
            this.modalTitle = 'MARITAL_STATUSES.SYNC.TITLE';
        },

        async confirmSync() {
            this.isSyncing = true;
            this.$store.commit('changeLoading', true);
            try {
                await maritalStatuses.synchronize();
                this.toast.success(this.t('MARITAL_STATUSES.SYNC.SUCCESS'));
                document.getElementById('closeX')?.click();
                await this.index();
            } catch (error) {
                this.errorMsg(error);
            } finally {
                this.isSyncing = false;
                this.$store.commit('changeLoading', false);
            }
        },

        async index(page = 1) {
            this.$store.commit('changeLoading', true);
            await maritalStatuses.index(page).then(resp => {
                this.items = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.errorMsg(error);
                this.$store.commit('changeLoading', false);
            });
            this.$store.commit('changeLoading', false);
        },

        updatePaginate(page) {
            this.updateItemsFromPaginate(page, maritalStatuses)
        },

        setEditModal(iten) {
            this.isSyncFlow = false;
            this.maritalStatus.id = iten.id;
            this.name = iten.name;
            this.maritalStatus.spouse_signature_required = iten.spouse_signature_required;
            this.modalTitle = 'MARITAL_STATUSES.MODAL_TITLE.EDIT';
        },

        setRegisterModal() {
            this.isSyncFlow = false;
            this.id = null;
            this.name = null;
            this.spouse_signature_required = false;
            this.modalTitle = 'MARITAL_STATUSES.MODAL_TITLE.ADD';
        },

        showAlert(id) {
            this.$swal.fire({
                title: this.t('GENERAL.MSG.REALLY_WANT_DELETE'),

                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Excluir`,
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);

                    maritalStatuses.delete(id).then(resp => {
                        document.getElementById('closeX').click();
                        this.index();
                        this.$store.commit('changeLoading', false);
                        this.toast.success(resp.data.validations.message);

                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error)
                    });
                }
            });
        },

        create() {
            this.startForm();

            if (this.checkForm()) {
                this.$store.commit('changeLoading', true);
                if (this.type.id) {
                    let data = this.type
                    let value = data.charge_expense
                    if (value) {
                        value = value.replace('R$ ', '');
                        value = value.replaceAll(".", "");
                        value = value.replaceAll(",", ".");
                        value = parseFloat(value).toFixed(2);
                        data.charge_expense = value;
                    }
                    if (data.charge_expense === undefined) {
                        data.charge_expense = 0.00
                    }
                    maritalStatuses.update(data).then(() => {
                        document.getElementById('closeX').click();
                        this.index();
                        this.$store.commit('changeLoading', false);
                        this.toast.success(this.t('GENERAL.MSG.UPDATE_SUCCESS'));
                        this.maritalStatus = {};
                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error);
                    });
                } else {
                    let data = this.type
                    let value = data.charge_expense
                    if (value) {
                        value = value.replace('R$ ', '');
                        value = value.replaceAll(".", "");
                        value = value.replaceAll(",", ".");
                        value = parseFloat(value).toFixed(2);
                        data.charge_expense = value;
                    }
                    if (data.charge_expense === undefined) {
                        data.charge_expense = 0.00
                    }
                    maritalStatuses.create(data).then(() => {
                        document.getElementById('closeX').click();
                        this.index();
                        this.$store.commit('changeLoading', false);
                        this.toast.success(this.t('GENERAL.MSG.REGISTER_SUCCESS'));
                        this.maritalStatus = {};
                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error);
                    });
                }
            }
        },

        checkForm() {
            this.nameValidate(this.name);

            if (this.invalid.length && this.invalid.length > 0) {
                return false;
            }
            return true;
        },

        startForm() {
            this.type = {
                id: this.maritalStatus.id,
                name: this.name,
                spouse_signature_required: this.maritalStatus.spouse_signature_required ?? false,
            }
            this.invalid = [];
        },

    }
});
</script>

<style>
.zIndex {
    z-index: 100000000000 !important;
}

.spin {
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.sync-list {
    list-style-type: disc;
    margin-left: 1.5rem;
    padding-left: 0.5rem;
}

.sync-list li {
    margin-bottom: 0.4rem;
    line-height: 1.4;
}
</style>
